import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./Common/ScrollToTop";

// ---------------- LOADER ----------------
const Loader = () => (
  <div style={{ textAlign: "center", padding: "100px", height:"100vh", width:"100%",justifyContent:"center", display:"flex", alignItems: "center"}}>
    <span class="loader"></span>
  </div>
);

// ---------------- HOME ----------------
const Home1 = lazy(() => import("./Pages/Home1"));
const Home2 = lazy(() => import("./Pages/Home2"));
const Home3 = lazy(() => import("./Pages/Home3"));
const Home4 = lazy(() => import("./Pages/Home4"));
const Home5 = lazy(() => import("./Pages/Home5"));
const Home6 = lazy(() => import("./Pages/Home6"));

// ---------------- ABOUT ----------------
const About1 = lazy(() => import("./Pages/About1"));
const About2 = lazy(() => import("./Pages/About2"));
const Afsluxe = lazy(() => import("./Pages/Afsluxe"));
const AfsPrint = lazy(() => import("./Pages/AfsPrint"));

// ---------------- SERVICES ----------------
const Services1 = lazy(() => import("./Pages/Services1"));
const Services2 = lazy(() => import("./Pages/Services2"));
const ServiceDetail = lazy(() => import("./Pages/ServiceDetail"));

// ---------------- TEAM ----------------
const Team1 = lazy(() => import("./Pages/Team1"));
const Team2 = lazy(() => import("./Pages/Team2"));
const TeamDetail = lazy(() => import("./Pages/TeamDetail"));

// ---------------- EXTRA ----------------
const OurHistory = lazy(() => import("./Pages/OurHistory"));
const FontIcons = lazy(() => import("./Pages/FontIcons"));
const Error = lazy(() => import("./Pages/Error"));

// ---------------- PROJECTS ----------------
const ProjectGrid3 = lazy(() => import("./Pages/ProjectGrid3"));
const ProjectGridNoGap3 = lazy(() => import("./Pages/ProjectGridNoGap3"));
const ProjectGrid4 = lazy(() => import("./Pages/ProjectGrid4"));
const ProjectGridNoGap4 = lazy(() => import("./Pages/ProjectGridNoGap4"));
const ProjectGrid5 = lazy(() => import("./Pages/ProjectGrid5"));
const ProjectGridNoGap5 = lazy(() => import("./Pages/ProjectGridNoGap5"));

const ProjectMasonary3 = lazy(() => import("./Pages/ProjectMasonary3"));
const ProjectMasonaryNoGap3 = lazy(() => import("./Pages/ProjectMasonaryNoGap3"));
const ProjectMasonary4 = lazy(() => import("./Pages/ProjectMasonary4"));
const ProjectMasonaryNoGap4 = lazy(() => import("./Pages/ProjectMasonaryNoGap4"));
const ProjectMasonary5 = lazy(() => import("./Pages/ProjectMasonary5"));
const ProjectMasonaryNoGap5 = lazy(() => import("./Pages/ProjectMasonaryNoGap5"));

const ProjectCorousel = lazy(() => import("./Pages/ProjectCorousel"));
const ProjectDetail1 = lazy(() => import("./Pages/ProjectDetail1"));
const ProjectDetail2 = lazy(() => import("./Pages/ProjectDetail2"));
const ProjectDetail = lazy(() => import("./Pages/ProjectDetails"));

// ---------------- BLOG ----------------
const BlogGrid = lazy(() => import("./Pages/BlogGrid"));
const BlogListing = lazy(() => import("./Pages/BlogListing"));
const BlogMasonary = lazy(() => import("./Pages/BlogMasonary"));
const BlogSingle = lazy(() => import("./Pages/BlogSingle"));
const PostRightSidebar = lazy(() => import("./Pages/PostRightSidebar"));

// ---------------- SHOP ----------------
const ShopGrid = lazy(() => import("./Pages/ShopGrid"));
const ShopList = lazy(() => import("./Pages/ShopList"));
const ShopDetail = lazy(() => import("./Pages/ShopDetail"));
const ShopAccount = lazy(() => import("./Pages/ShopAccount"));
const ShopCart = lazy(() => import("./Pages/ShopCart"));
const ShopCheckout = lazy(() => import("./Pages/ShopCheckout"));

// ---------------- OTHERS ----------------
const Faq = lazy(() => import("./Pages/Faq"));
const ContactUs = lazy(() => import("./Pages/ContactUs"));

class Components extends React.Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <ScrollToTop />

        <div className="page-wraper">
          <Suspense fallback={<Loader />}>
            <Routes>

              {/* HOME */}
              <Route path="/" element={<Home1 />} />
              <Route path="/home-2" element={<Home2 />} />
              <Route path="/home-3" element={<Home3 />} />
              <Route path="/home-4" element={<Home4 />} />
              <Route path="/home-5" element={<Home5 />} />
              <Route path="/home-6" element={<Home6 />} />

              {/* ABOUT */}
              <Route path="/about-1" element={<About1 />} />
              <Route path="/afs-dote-about-us" element={<About2 />} />
              <Route path="/afs-luxe-about-us" element={<Afsluxe />} />
              <Route path="/afs-printing-about-us" element={<AfsPrint />} />

              {/* SERVICES */}
              <Route path="/services-1" element={<Services1 />} />
              <Route path="/services-2" element={<Services2 />} />
              <Route path="/services-detail" element={<ServiceDetail />} />

              {/* TEAM */}
              <Route path="/team-1" element={<Team1 />} />
              <Route path="/team-2" element={<Team2 />} />
              <Route path="/team-single" element={<TeamDetail />} />

              {/* EXTRA */}
              <Route path="/our-history" element={<OurHistory />} />
              <Route path="/icon-font" element={<FontIcons />} />

              {/* PROJECTS */}
              <Route path="/project-grid-3-columns" element={<ProjectGrid3 />} />
              <Route path="/project-grid-3-columns/:category" element={<ProjectGrid3 />} />
              <Route path="/project/:id" element={<ProjectDetail />} />
              <Route path="/project-grid-3-columns-no-gap" element={<ProjectGridNoGap3 />} />

              <Route path="/project-grid-4-columns" element={<ProjectGrid4 />} />
              <Route path="/project-grid-4-columns-no-gap" element={<ProjectGridNoGap4 />} />
              <Route path="/project-grid-5-columns" element={<ProjectGrid5 />} />
              <Route path="/project-grid-5-columns-no-gap" element={<ProjectGridNoGap5 />} />

              <Route path="/project-masonry-3-columns" element={<ProjectMasonary3 />} />
              <Route path="/project-masonry-3-columns-no-gap" element={<ProjectMasonaryNoGap3 />} />
              <Route path="/project-masonry-4-columns" element={<ProjectMasonary4 />} />
              <Route path="/project-masonry-4-columns-no-gap" element={<ProjectMasonaryNoGap4 />} />
              <Route path="/project-masonry-5-columns" element={<ProjectMasonary5 />} />
              <Route path="/project-masonry-5-columns-no-gap" element={<ProjectMasonaryNoGap5 />} />

              {/* BLOG */}
              <Route path="/blog-grid" element={<BlogGrid />} />
              <Route path="/blog-listing" element={<BlogListing />} />
              <Route path="/blog-masonry" element={<BlogMasonary />} />
              <Route path="/blog-single" element={<BlogSingle />} />
              <Route path="/post-right-sidebar" element={<PostRightSidebar />} />

              {/* SHOP */}
              <Route path="/shop-grid" element={<ShopGrid />} />
              <Route path="/shop-list" element={<ShopList />} />
              <Route path="/shop-detail" element={<ShopDetail />} />
              <Route path="/shop-account" element={<ShopAccount />} />
              <Route path="/shop-cart" element={<ShopCart />} />
              <Route path="/shop-checkout" element={<ShopCheckout />} />

              {/* OTHERS */}
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact-us" element={<ContactUs />} />

              {/* 404 */}
              <Route path="*" element={<Error />} />

            </Routes>
          </Suspense>
        </div>
      </BrowserRouter>
    );
  }
}

export default Components;
